import { defineMessages } from 'react-intl';

const messages = defineMessages({
  manageSettings: {
    description: 'dropdown item to edit addon settings',
    defaultMessage: 'Manage Settings',
    id: 'tkFBgj',
  },
  openReturnRabbit: {
    description: 'dropdown item to open tab to Return Rabbit site',
    defaultMessage: 'Open Return Rabbit',
    id: 'RNUMYN',
  },
  configureAccount: {
    description: 'bespoke dropdown item to configure account for Return Rabbit',
    defaultMessage: 'Configure Account',
    id: 'MMKoVu',
  },
  deactivate: {
    description: 'dropdown item that opens the add-on deactivation modal',
    defaultMessage: 'Deactivate',
    id: 'soEwo/',
  },
  addOnMenuAriaLabel: {
    description: 'the is the accessibilty label for the action menu button',
    defaultMessage: 'add-ons-action-menu',
    id: 'Cwgpqs',
  },
  learnMore: {
    defaultMessage: 'Learn More',
    id: 'UJrgkE',
    description: 'Learn More link that links out to a knowledge base article for the Add-On',
  },
  reactivate: {
    defaultMessage: 'Reactivate',
    id: 'vO7Jnx',
    description: 'Drop down action that will allow the user to reactivate an Add-On that is going to deactivate soon',
  },
});

export default messages;
